// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'

// Internal Dependencies:
import Link from 'components/Link/Link'
import { loop } from 'utilities/objects'

class HonourTypes extends React.Component {
	constructor() {
		super()

		this.state = {
			showContent: false
		}
	}

	componentDidMount() {
		this._isMounted = true

		this.update()
	}

	componentWillUnmount() {
		this._isMounted = false
	}

	componentDidUpdate( prevProps, prevState ) {
		this.update()
	}

	update = () => {
		const { history } = this.props
		const { showContent } = this.state

		if ( 'POP' == history.action && ! showContent ) {
			setTimeout( () => {
				this.setState( {
					showContent: true
				} )
			}, 400 )
		}
	}

	render() {
		const { postsData, match, location, history } = this.props
		const { showContent } = this.state

		if ( 'POP' == history.action && ! showContent ) {
			return null
		}

		return (
			<div className="page-sections-wrap">
				<div className="page-sections">
					<section className="page-section page-section-honours is-honours-types is-odd">
						<div className="js-scroll-position"></div>

						<div className="-posts">
							<div className="-inner">
								<div className="-items">
									<Link to="/honours/" className="-item">
										<div className="-inner">
											<div className="-arrow" />

											<div className="-text">
												<h3>Honours</h3>
											</div>
										</div>
									</Link>

									<Link to="/master-honours/" className="-item">
										<div className="-inner">
											<div className="-arrow" />

											<div className="-text">
												<h3>Master Honours</h3>
											</div>
										</div>
									</Link>

									<Link to="/new-honours/" className="-item">
										<div className="-inner">
											<div className="-arrow" />

											<div className="-text">
												<h3>New Honours</h3>
											</div>
										</div>
									</Link>

									<Link to="/new-honour-templates/" className="-item">
										<div className="-inner">
											<div className="-arrow" />

											<div className="-text">
												<h3>New Honour Templates</h3>
											</div>
										</div>
									</Link>

									<Link to="/revised-honours/" className="-item">
										<div className="-inner">
											<div className="-arrow" />

											<div className="-text">
												<h3>Revised Honours</h3>
											</div>
										</div>
									</Link>
								</div>
							</div>
						</div>
					</section>
				</div>
			</div>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		postsData: state.page.selected
	}
}

export default connect( mapStateToProps )( HonourTypes )



// WEBPACK FOOTER //
// ./components/Honours/HonourTypes.jsx